var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-custom-text",style:({background: _vm.bgColor, height: _vm.height ? (_vm.height + 'px') : undefined, 'justify-content': _vm.valign, padding: _vm.padding + 'px'})},[_c('div',{style:(_vm.getStyle)},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }